const mockAvatars = [
	'/media/avatars/300-1.jpg',
	'/media/avatars/300-2.jpg',
	'/media/avatars/300-3.jpg',
	'/media/avatars/300-4.jpg',
	'/media/avatars/300-5.jpg',
	'/media/avatars/300-6.jpg',
	'/media/avatars/300-7.jpg',
	'/media/avatars/300-8.jpg',
	'/media/avatars/300-9.jpg',
	'/media/avatars/300-10.jpg',
]

export const MOCK_DATA: any[] = [
	{
		uuId: '1234567890',
		code: 'ORD-0001',
		status: '10',
		items: [
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 10,
				},
				quantity: 10,
			},
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 20,
				},
				quantity: 20,
			},
		],
		buyer: {
			featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
			fullnameTh: 'นาย สมชาย ใจดี',
			fullnameEn: 'Mr. Somchai Jaidi',
			email: 'somchai@jaidi.com',
			uuId: '1234567890',
		},
	},
	{
		uuId: '1234567890',
		code: 'ORD-0002',
		status: '20',
		items: [
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 10,
				},
				quantity: 10,
			},
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 20,
				},
				quantity: 20,
			},
		],
		buyer: {
			featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
			fullnameTh: 'นาง สมหญิง ใจดี',
			fullnameEn: 'Mrs. Somching Jaidi',
			email: 'somching@jaidi.com',
			uuId: '0987654321',
		},
	},
	{
		uuId: '1234567890',
		code: 'ORD-0003',
		status: '30',
		items: [
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 10,
				},
				quantity: 10,
			},
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 20,
				},
				quantity: 20,
			},
		],
		buyer: {
			featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
			fullnameTh: 'นาย สมหมาย ใจดี',
			fullnameEn: 'Mr. Sommai Jaidi',
			email: 'sommai@jaidi.com',
			uuId: '0987654321',
		},
	},
	{
		uuId: '1234567890',
		code: 'ORD-0004',
		status: '40',
		items: [
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 10,
				},
				quantity: 10,
			},
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 20,
				},
				quantity: 20,
			},
		],
		buyer: {
			featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
			fullnameTh: 'นาง สมหมาย ใจดี',
			fullnameEn: 'Mrs. Sommai Jaidi',
			email: 'sommaiwoman@jaidi.com',
			uuId: '0987654321',
		},
	},
	{
		uuId: '1234567890',
		code: 'ORD-0005',
		status: '50',
		items: [
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 10,
				},
				quantity: 10,
			},
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 20,
				},
				quantity: 20,
			},
		],
		buyer: {
			featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
			fullnameTh: 'นาย สมหมาย ใจดี',
			fullnameEn: 'Mr. Sommai Jaidi',
			email: 'sommai@jaidi.com',
			uuId: '0987654321',
		},
	},
	{
		uuId: '1234567890',
		code: 'ORD-0006',
		status: '60',
		items: [
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 10,
				},
				quantity: 10,
			},
			{
				product: {
					name: 'กล่องไปรษณีย์ไซส์ A',
					description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
					featurePicturePath: '/media/kumopack-products/1.svg',
					price: 20,
				},
				quantity: 20,
			},
		],
		buyer: {
			featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
			fullnameTh: 'นาง สมหมาย ใจดี',
			fullnameEn: 'Mrs. Sommai Jaidi',
			email: 'sommai@jaidee.com',
			uuId: '0987654321',
		},
	},
]

export const MOCK_DATA_DETAIL: any = {
	uuId: '1234567890',
	code: 'ORD-0001',
	status: '10',
	items: [
		{
			product: {
				name: 'กล่องไปรษณีย์ไซส์ A',
				description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
				featurePicturePath: '/media/kumopack-products/1.svg',
				price: 10,
			},
			quantity: 10,
		},
		{
			product: {
				name: 'กล่องไปรษณีย์ไซส์ A',
				description: 'กล่องไปรษณีย์ไซส์ A ขนาด 10x10x10 ซม. สีขาว',
				featurePicturePath: '/media/kumopack-products/1.svg',
				price: 20,
			},
			quantity: 20,
		},
	],
	buyer: {
		featurePicturePath: mockAvatars[Math.floor(Math.random() * mockAvatars.length)],
		fullnameTh: 'นาย สมชาย ใจดี',
		fullnameEn: 'Mr. Somchai Jaidi',
		email: 'somchai@jaidi.com',
		uuId: '1234567890',
		code: 'BA-0001',
	},
}
